import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { useUI, useActions } from '../../context/AppContext';
import { COMMON_INPUT_CLASS, WORKOUT_TEMPLATES } from '../../utils/constants';

const WorkoutProgramForm = ({ student, onSuccess }) => {
  const { showToast } = useUI();
  const { createProgram } = useActions();
  const [form, setForm] = useState({
    targetDate: '', warmup: '', main: '', cooldown: '',
  });
  const [submitting, setSubmitting] = useState(false);

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        if (submitting) return;
        setSubmitting(true);
        try {
          await createProgram(student, {
            dateISO: form.targetDate,
            warmup: form.warmup,
            main: form.main,
            cooldown: form.cooldown,
          });
          onSuccess();
          showToast('Görev eklendi.');
        } catch (err) {
          showToast('Görev eklenirken bir hata oluştu.', 'error');
        } finally {
          setSubmitting(false);
        }
      }}
      className="space-y-4"
    >
      <div className="mb-4">
        <label className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase mb-2 block">
          Hazır Şablonlar
        </label>
        <div className="flex gap-2 overflow-x-auto pb-2 custom-scrollbar">
          {WORKOUT_TEMPLATES.map((t, idx) => {
            const Icon = t.icon;
            return (
              <button
                type="button"
                key={idx}
                onClick={() =>
                  setForm((prev) => ({
                    ...prev, warmup: t.warmup, main: t.main, cooldown: t.cooldown,
                  }))
                }
                className="whitespace-nowrap flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 dark:bg-blue-900/30 hover:bg-blue-100 dark:hover:bg-blue-900/50 text-blue-600 dark:text-blue-400 rounded-lg text-xs font-bold transition-colors border border-blue-100 dark:border-blue-800"
              >
                <Icon size={14} /> {t.name}
              </button>
            );
          })}
        </div>
      </div>

      <div>
        <label className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase mb-1 block">
          Tarih
        </label>
        <input
          type="date"
          required
          value={form.targetDate}
          onChange={(e) => setForm({ ...form, targetDate: e.target.value })}
          className={COMMON_INPUT_CLASS}
        />
      </div>

      <div>
        <label className="text-xs font-bold text-orange-500 uppercase">Isınma Seti</label>
        <input
          required
          placeholder="Örn: 500m Serbest Stil"
          value={form.warmup}
          onChange={(e) => setForm({ ...form, warmup: e.target.value })}
          className={COMMON_INPUT_CLASS}
        />
      </div>
      <div>
        <label className="text-xs font-bold text-blue-500 uppercase">Ana Set</label>
        <textarea
          required
          placeholder="Örn: 10x100m Tempo"
          value={form.main}
          onChange={(e) => setForm({ ...form, main: e.target.value })}
          className={`${COMMON_INPUT_CLASS} h-20 resize-none`}
        />
      </div>
      <div>
        <label className="text-xs font-bold text-emerald-500 uppercase">Soğuma Seti</label>
        <input
          required
          placeholder="Örn: 200m Gevşeme"
          value={form.cooldown}
          onChange={(e) => setForm({ ...form, cooldown: e.target.value })}
          className={COMMON_INPUT_CLASS}
        />
      </div>

      <button
        type="submit"
        disabled={submitting}
        className="w-full bg-slate-900 dark:bg-blue-600 text-white py-4 rounded-xl font-bold mt-4 hover:bg-slate-800 dark:hover:bg-blue-700 transition-colors flex justify-center items-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
      >
        <Plus size={18} /> {submitting ? 'Ekleniyor...' : 'Görevi Ekle'}
      </button>
    </form>
  );
};

export default WorkoutProgramForm;
